"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getBoatCaptCrewTotalFromOriginalRates(rates, durationType, customDuration) {
    let boatCaptCrewTotal = 0;
    const rateTypes = ['Owner', 'Captain', 'Crew'];
    if (durationType === 4 || customDuration == 4) {
        // half day
        rates.forEach(rate => {
            if (rateTypes.includes(rate.rateType)) {
                boatCaptCrewTotal +=
                    rate.halfDayRate + rate.halfDayRate * rate.markupPercentage;
            }
        });
    }
    else if (durationType === 8 || customDuration == 8) {
        // full day
        rates.forEach(rate => {
            if (rateTypes.includes(rate.rateType)) {
                boatCaptCrewTotal +=
                    rate.fullDayRate + rate.fullDayRate * rate.markupPercentage;
            }
        });
    }
    else if (customDuration > 4 && customDuration < 8) {
        // custom duration (5hrs - 7hrs)
        rates.forEach(rate => {
            if (rateTypes.includes(rate.rateType)) {
                let additionalHoursTotal = rate.halfDayRate + rate.hourlyRate * (customDuration - 4);
                boatCaptCrewTotal +=
                    additionalHoursTotal + additionalHoursTotal * rate.markupPercentage;
            }
        });
    }
    else if (customDuration > 8) {
        // custom duration (8+ hrs)
        rates.forEach(rate => {
            if (rateTypes.includes(rate.rateType)) {
                let additionalHoursTotal = rate.fullDayRate + rate.hourlyRate * (customDuration - 8);
                boatCaptCrewTotal +=
                    additionalHoursTotal + additionalHoursTotal * rate.markupPercentage;
            }
        });
    }
    else if (customDuration < 4 && customDuration > 0) {
        // custom duration (1hrs - 3hrs)
        rates.forEach(rate => {
            if (rateTypes.includes(rate.rateType)) {
                let additionalHoursTotal = rate.halfDayRate - rate.hourlyRate * (4 - customDuration);
                boatCaptCrewTotal +=
                    additionalHoursTotal + additionalHoursTotal * rate.markupPercentage;
            }
        });
    }
    return parseFloat(boatCaptCrewTotal.toFixed(2));
}
exports.getBoatCaptCrewTotalFromOriginalRates = getBoatCaptCrewTotalFromOriginalRates;
